export default __webpack_public_path__ + "static/media/step2bDarkMode.4b710628.svg";